module.exports = __webpack_public_path__ + "static/brush-yellow-corner-right-c0bd2d9668563e90c34e69d842f33286.png";